import { styled, Box } from '@mui/material';

var BOX_VERTICAL_PADDING = 30;
var MASONRY_SPACING = 20;
var MASONRY_SPACING_MARGIN = MASONRY_SPACING / 2;
var StyledBox = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingTop: "".concat(Math.max(BOX_VERTICAL_PADDING - MASONRY_SPACING_MARGIN, 0), "px"),
        margin: "0 auto",
        '.wrap-text': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        a: {
            fontWeight: 500,
            marginBottom: 10,
            '&.bold': {
                fontWeight: 600,
            },
            '&:hover': {
                textDecoration: 'underline !important',
            },
        },
        'span.group-name': {
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 16,
        },
    });
});

export { BOX_VERTICAL_PADDING, MASONRY_SPACING, MASONRY_SPACING_MARGIN, StyledBox };
//# sourceMappingURL=CategoriesDropdownStyles.js.map
